import React from 'react';
import LocationsList from '../components/dynamic/LocationsList.tsx';
import { Box, styled, Typography, useTheme } from '@mui/material';


const HeaderSection = styled(Box)(({ theme }) => ({
    background: `linear-gradient(to right, ${theme.palette.primary.main}, ${theme.palette.background.paper})`,
    padding: "40px 20px",
    textAlign: "center",
    borderBottomLeftRadius: "30px",
    borderBottomRightRadius: "30px",
    color: theme.palette.text.primary,
}));


const Locations: React.FC = () => {
    const theme = useTheme(); // Get theme colors


    return (
        <Box sx={{ backgroundColor: theme.palette.background.default }}>
            <HeaderSection>
                <Typography variant="h4" fontWeight="bold">
                    Laundromat Locations
                </Typography>
                <Typography variant="subtitle1">
                    Visit any of our locations for service today!
                </Typography>
            </HeaderSection>
            <LocationsList />
        </Box>
    );
}


export default Locations;